var windowsize = $(window).width();

// Disabled links
$(document).on("click", "a[disabled]", function(e) {
	e.preventDefault();
	e.stopPropagation();
	e.stopImmediatePropagation();
});
// ok
// Attach dynamic click listeners
$(document).on("click", "[data-trigger=click]", function(e) {

    if ($(this).data()["preventDefault"]) {
        e.preventDefault();
    }

    var params = [];

    if ($(this).attr("data-params")) {
        params = eval("[" + $(this).attr("data-params") + "]");
    }

    params.push(e);

    var controller = eval($(this).attr("data-controller"));
    controller.apply(this, params);
});

$(".no-ajax-form").on("submit", function() {
	$(this).data("loading", true);
	$(this).find("button[type=submit], button:not([type])")
		.addClass("btn--loading")
		.attr("disabled", true)
		.prop("disabled", true);
});

// Header
$('.header__login-wrapper').click(function() {
  if(windowsize <= 992) {
    $(this).toggleClass('show-menu');
  }
});

// Fixed nav to top on small
$(window).scroll(function () {
  if ($(window).scrollTop() >= 250) {
    $('body').addClass('fixed-top');
  } else {
      $('body').removeClass('fixed-top');
  }
});

$("#nav-trigger").on( "click" , function(e) {
	e.preventDefault();

	var $body = $(document.body);

	if ($body.hasClass("nav-visible")) {
		$body.removeClass("nav-visible");
		$(window).scrollTop(beforeNavScroll);
	}
	else {
		beforeNavScroll = $(window).scrollTop();
		$body.addClass("nav-visible");
	}
});

if(windowsize <= 950) {
  $('.bottom-nav__item--has-childrens').on('click', function(e) {
    // e.preventDefault();
    event.stopPropagation();
    $(this).toggleClass('bottom-nav__item--has-childrens-open');
  });
}

$('.main-nav__child-toggler').on('click', function(e) {
  // e.preventDefault();
  event.stopPropagation();
  $(this).closest(".bottom-nav__item--has-childrens").toggleClass('bottom-nav__item--has-childrens-open');
});

//Filters
$(".btn--filter").on("click", function () {
	$(".filters").toggleClass('show-filter');
	$(".page-overlay").toggleClass("page-overlay--visible");
});

$(".btn--close-filter").on("click", function () {
	$(".filters").removeClass('show-filter');
	$(".page-overlay").removeClass("page-overlay--visible");
});

if(windowsize <= 950) {
  $(window).scroll(function () {
    if ($(window).scrollTop() >= 350) {
      $('.btn--filter-icon').addClass('move-top');
    } else {
        $('.btn--filter-icon').removeClass('move-top');
    }
  });
} 
else if(windowsize <= 992 && windowsize >= 950) {
    $(window).scroll(function () {
      if ($(window).scrollTop() >= 300) {
      $('.btn--filter-icon').addClass('move-top');
    } else {
      $('.btn--filter-icon').removeClass('move-top');
    }
  });
}

// See all checkboxes
// Get all of checkboxes that are in the filter
const checks = document.querySelectorAll('.filters .form__group--checkbox');
//Convert the nodelist in an array
const checksArr = Array.from(checks);
//Get only first three elements from the array
const firstChecks = checksArr.slice(0,3);
// Get show button
const showAllBtn = document.querySelector('.filter__checkbox--all');

if(checks) {
  firstChecks.forEach(e => {
    e.style.display = 'block';
  });

  checksArr.forEach(e => {
    if (showAllBtn) {
      showAllBtn.addEventListener('click', function() {
        e.classList.toggle('visible-checkbox');
      });
    }
  });
}

$(".filter__checkbox--all").click(function(){
  $(this).text($(this).text() == 'Виж повече' ? 'Скрий' : 'Виж повече');
  $(this).toggleClass('toggle-arrow');
});

const checkAgree = document.querySelector(".agree-checkbox");

if(checkAgree) {
  $(".agree-checkbox").click(function() {
      if($(".btn--confirm").attr('disabled')) {
        $(".btn--confirm").removeAttr("disabled");
        
      } else {
        $(".btn--confirm").attr("disabled", "disabled");
      }
  });
}

$( document ).ready(function() {
    if( $('#checkbox').is(':checked')) {
      $(".btn--confirm").removeAttr("disabled");
    }
});

// Forms
$('.cart .form__input--select').on('click', function(e) {
  $(this).toggleClass('rotateArrow');
});

// Floating labels
$(":input").on("focus", function() {

	var group = $(this).closest(".form__group");
	group.addClass("form__group--focused");

});

$(":input").on("blur", function() {
	
	var group = $(this).closest(".form__group");
	group.removeClass("form__group--focused");

});

$(":input").on("change", function() {

	var group = $(this).closest(".form__group");

	if (
		($(this).val() !== null && $(this).val() !== "") ||
	 	$(this).is("select")
	) {
		group.addClass("form__group--filled");
	}
	else {
		group.removeClass("form__group--filled");
	}

}).change();

$(":input").on("input", function() {

	var group = $(this).closest(".form__group");
	var append = group.find(".form__append-fix")

	append.html($(this).val().replace(new RegExp(" ", "g"), "&nbsp;"));

});

// Inner
//Take first letter from client review name
$('.client-name').each(function(i, el) {
  var firstLetter = $(el).data('name').charAt(0);
  var letterSpaceHolder = $(el).parent().siblings()[0];
  $(letterSpaceHolder).text(firstLetter);
});

// Back to top button
var btn = $('#back-to-top-button');

$(window).scroll(function() {
  if ($(window).scrollTop() > 300) {
    btn.addClass('show');
  } else {
    btn.removeClass('show');
  }
});

btn.on('click', function(e) {
  e.preventDefault();
  $('html, body').animate({scrollTop:0}, '300');
});

// scroll to video
$('.product-gallery__thumb--video').click(function() {
    $('html, body').animate({
      scrollTop: $("#video").offset().top
  }, 1500);
});

//Photoswipe init
if ($(".slider-exemplary-pricing").length) {
  // Photoswipe init        
  $(".slider-exemplary-pricing").photoSwipe(
      ".lightbox-container",
      {
          bgOpacity: 0.8,
          shareEl: false,
          captionEl: false,
          tapToClose: true,
      }
  );
}

$(document).on('click', '.clever-link', function(e){
  if($(this).data('prevent')) {
    return false;
  } else {
    window.open($(this).data('link'), "_self");
  }
  
});


$(window).on('load', function() {
  (function() {
    var texts = $('.read-more-text');
  
    texts.each(function() {
      var text = $(this),
        parent = text.parent('div'),
        btn    = parent.find('.morelink'),
        wait   = text.data('wait'),
        height = text.data('height');
      if(text.length) {
      
        setTimeout(function() { 
          text.css('overflow', 'hidden');
          text.addClass('visible');
          text.animate({'height': height}); 
        }, wait);
     
        var h = text[0].scrollHeight;
        if(h > height) {
          btn.addClass('less');
          btn.css('display', 'inline-block');
        }
      
        btn.click(function(e) {
          e.stopPropagation();
      
          if(btn.hasClass('less')) {
            btn.removeClass('less');
            btn.addClass('more');
            btn.text('Скрий');
            text.css('overflow', 'visible');
            text.removeClass('visible');
            text.animate({'height': h});
          } else {
            btn.addClass('less');
            btn.removeClass('more');
            btn.text('Прочети още');
            text.css('overflow', 'hidden');
            text.addClass('visible');
            text.animate({'height': height});
          }
        });
      }
    });
  })();
});


// Multi select

// $(document).ready(function() {
//   $('.filters select').select2({
//     placeholder: "Моля изберете",
//     allowClear: true
// });
// });

// $('.filter--select').each(function(ind, val) {
//   $(this).click(function() {
//     var select = $(this).find($('.select2-selection__rendered'));
//     select.toggleClass('rotateArrow');
//   });
// });

// Change phone format
// let phone = document.getElementById('telephone').innerText;

// phone = phone.replace(/[^\d]+/g, '')
//      .replace(/(\d{3})(\d{3})(\d{3})(\d{3})/, '+$1 ($2) $3 $4');

// document.getElementById('telephone').innerText = phone;

//Increment/decrement btns
function incrementValue(e) {
  e.preventDefault();
  var fieldName = $(e.target).data('field');
  var parent = $(e.target).closest('div');
  var currentVal = parseInt(parent.find('input[name=' + fieldName + ']').val(), 10);

  if (!isNaN(currentVal)) {
    parent.find('input[name=' + fieldName + ']').val(currentVal + 1);
  } else {
    parent.find('input[name=' + fieldName + ']').val(0);
  }
}

function decrementValue(e) {
  e.preventDefault();
  var fieldName = $(e.target).data('field');
  var parent = $(e.target).closest('div');
  var currentVal = parseInt(parent.find('input[name=' + fieldName + ']').val(), 10);

  if (!isNaN(currentVal) && currentVal > 0) {
    parent.find('input[name=' + fieldName + ']').val(currentVal - 1);
  } else {
    parent.find('input[name=' + fieldName + ']').val(0);
  }
}

$('.input-group').on('click', '.button-plus', function(e) {
  incrementValue(e);
});

$('.input-group').on('click', '.button-minus', function(e) {
  decrementValue(e);
});